"use strict";

const MemberEorrorCode = [
  { code: 21013, message: "windows device info is wrong	window device 정보가 잘못되었습니다." },
  { code: 22004, message: "verification not found	인증오류" },
  { code: 21014, message: "validation failed for argument	변수에 대하여 유효성이검사에 실패하였습니다." },
  { code: 21007, message: "user info is wrong	유저 정보가 잘못되었습니다." },
  { code: 24002, message: "unsupported media type	지원하지 않은 유형입니다." },
  { code: 29999, message: "unknown server error	System 오류" },
  { code: 22001, message: "sign up token is invalid	회원가입 세션토큰 오류" },
  { code: 21003, message: "service code is wrong	서비스 코드가 잘못 되었습니다." },
  { code: 25005, message: "return to error from gds	GDS 결과 오류" },
  { code: 25007, message: "overtime authentication verify	인증코드 유효시간 오류" },
  { code: 21010, message: "os code is wrong	Os Code 가 잘못되었습니다." },
  { code: 25007, message: "not support social	지원되지 않는 소셜 정보" },
  { code: 23003, message: "not signup service	회원가입 서비스가 아닙니다." },
  { code: 23001, message: "not found user	유저정보를 찾을 수 없습니다." },
  { code: 23028, message: "이미 사용중인 이메일입니다." },
  { code: 23029, message: "이미 사용중인 휴대폰번호입니다." },
  { code: 25005, message: "No request authentication	요청된 인증정보가 없습니다." },
  { code: 24001, message: "method not allowed	잘못 정의 된 Method" },
  { code: 21009, message: "member no is wrong	회원번호가 잘못되었습니다." },
  { code: 21006, message: "language is wrong	언어가 잘못되었습니다." },
  { code: 21012, message: "ios device info is wrong	ios device 정보가 잘못되었습니다." },
  { code: 23002, message: "invalid user state	잘못된 유저 상태 입니다." },
  { code: 22005, message: "invalid terms	약관이 유효하지 않습니다." },
  { code: 25008, message: "invalid social code	소셜 코드가 잘못되었습니다." },
  { code: 25001, message: "Invalid Session Key	잘못된 Session Key 입니다." },
  { code: 23005, message: "invalid id type	잘못된 ID 타입입니다." },
  { code: 22007, message: "invalid client secret	잘못된 Client Secret 입니다." },
  { code: 22006, message: "invalid client id	잘못된 Client ID 입니다." },
  { code: 23004, message: "invalid authentication	잘못된 인증정보입니다." },
  { code: 25006, message: "Invalid auth code	잘못된 인증코드 입니다." },
  { code: 25001, message: "failed to send sms	SMS 전송 실패" },
  { code: 25008, message: "failed to select authentication information	인증정보 체크 실패" },
  { code: 25004, message: "Failed to save redis	redis 저장 실패" },
  { code: 25003, message: "Failed to save authentication information	인증정보 저장 실패" },
  { code: 25002, message: "failed to parse sms data	SMS DATA 분석 실패" },
  { code: 25006, message: "failed to get gds value	GDS VALUE 오류" },
  { code: 25002, message: "Failed to generate Session Key	Session Key 생성이 실패하였습니다." },
  { code: 24001, message: "failed to create password	패스워드 생성 실패" },
  { code: 25003, message: "failed to connect sms	SMS 업체 연결 실패" },
  { code: 25004, message: "failed to connect gds	GDS 연결 실패" },
  { code: 21005, message: "country no is wrong	국가번호가 잘못 되었습니다." },
  { code: 21002, message: "country code is wrong	국가 코드가 잘못 되었습니다." },
  { code: 21001, message: "client ip is wrong	Client IP 가 잘못 되었습니다." },
  { code: 21008, message: "client id is wrong	Client ID 가 잘못되었습니다." },
  { code: 21015, message: "bad member service type	잘못된 회원 서비스 유형" },
  { code: 21016, message: "bad legacy password	기존 서비스 회원 패스워드가 잘못되었습니다." },
  { code: 21004, message: "authorization is wrong	인증정보가 잘못되었습니다." },
  { code: 21011, message: "android device info is wrong	Android device 정보가 잘못되었습니다." },
  { code: 22002, message: "already registered with token	이미 등록 된 토큰" },
  { code: 22003, message: "already registered with email	중복된 이메일정보" },
  { code: 22011, message: "이미 등록된 닉네임입니다." },
  { code: 23028, message: "이미 사용중인 이메일 주소입니다." },
  { code: 23029, message: "이미 사용중인 휴대폰 번호입니다." },
  { code: 22022, message: "19세 미만은 보호자(법정대리인) 동의가 불가합니다." }
];

export default MemberEorrorCode;
